export default "__VITE_ASSET__D7oK9YV6__"